import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import Button from '../components/common/Button';
import { fadeIn } from '../utils/gsapAnimations';

function Wishlist() {
  const pageRef = useRef(null);
  const { wishlist, removeFromWishlist } = useWishlist();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  return (
    <div ref={pageRef} className="bg-cream">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-lora font-semibold text-burgundy mb-6">Your Wishlist</h1>
        {wishlist.length === 0 ? (
          <div className="text-center">
            <p className="text-poppins text-burgundy mb-4">Your wishlist is empty.</p>
            <Link to="/shop">
              <Button>Shop Now</Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {wishlist.map((product) => (
              <div key={product.id} className="bg-cream rounded-lg shadow-md p-4">
                <Link to={`/product/${product.id}`}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 object-cover rounded-lg"
                  />
                </Link>
                <h3 className="text-lg font-poppins font-semibold text-burgundy mt-2">{product.name}</h3>
                <p className="text-poppins text-burgundy">${product.price.toFixed(2)}</p>
                <button
                  onClick={() => removeFromWishlist(product.id)}
                  className="text-poppins text-burgundy mt-2 hover:underline"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Wishlist;